__turbopack_context__.v({
  "content": "modalContent-module-scss-module__Z1_zta__content",
  "enter": "modalContent-module-scss-module__Z1_zta__enter",
  "exit": "modalContent-module-scss-module__Z1_zta__exit",
  "fade-in": "modalContent-module-scss-module__Z1_zta__fade-in",
  "fade-out": "modalContent-module-scss-module__Z1_zta__fade-out",
  "fade-out-80": "modalContent-module-scss-module__Z1_zta__fade-out-80",
  "slide-in-from-bottom": "modalContent-module-scss-module__Z1_zta__slide-in-from-bottom",
  "slide-in-from-left": "modalContent-module-scss-module__Z1_zta__slide-in-from-left",
  "slide-in-from-right": "modalContent-module-scss-module__Z1_zta__slide-in-from-right",
  "slide-in-from-top": "modalContent-module-scss-module__Z1_zta__slide-in-from-top",
  "slide-out-to-bottom": "modalContent-module-scss-module__Z1_zta__slide-out-to-bottom",
  "slide-out-to-left": "modalContent-module-scss-module__Z1_zta__slide-out-to-left",
  "slide-out-to-right": "modalContent-module-scss-module__Z1_zta__slide-out-to-right",
  "slide-out-to-top": "modalContent-module-scss-module__Z1_zta__slide-out-to-top",
  "zoom-in": "modalContent-module-scss-module__Z1_zta__zoom-in",
  "zoom-out": "modalContent-module-scss-module__Z1_zta__zoom-out",
});
